import React from 'react';
import { volumes } from '../data/volumes';
const everyVolume = ['15 sessions as 2-page spreads: the plan & stations, then how to run it', '4 worksheets and a pocket field card', '20+ players? Station set-ups with helpers, space and ratios', 'One station at three levels for mixed squads'];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-cream-light text-ink" data-id="element-375" data-mp="1p0mjf0x6i6k2">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-376" data-mp="1l0c8rayfyryv">
        <div className="text-center" data-id="element-377" data-mp="1fzy8wg6zuobx">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-grass-deep" data-id="element-378" data-mp="1fywkla0yw5c9">Your whole season</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl text-ink sm:text-5xl" data-id="element-379" data-mp="1b1mv5udkvtof">
            Inside the pack: six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-380" data-mp="35fnvkjos0oqm">
            The season in the order you coach it: foundations first, then batting,
            bowling, fielding, match sense and a strong finish. Each volume stands
            on its own, so open the one your squad needs this week.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-381" data-mp="2chl4kj2upvwh">
          {volumes.map(vol => <article key={vol.number} className={`flex flex-col rounded-2xl border bg-white p-6 shadow-soft ${vol.flag ? 'border-grass-deep ring-1 ring-grass-deep' : 'border-cream-dark'}`} data-id="element-382" data-mp="1xkkai8x6touu">
              <div className="flex items-center gap-2.5" data-id="element-383" data-mp="2v5gbbj01q9g3">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg font-display text-base font-extrabold ${vol.badge}`} data-id="element-384" data-mp="2ghlje4tv4942">
                  {vol.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-widest text-ink-muted" data-id="element-385" data-mp="3960uwhdsc9an">
                  Volume {vol.number}
                </span>
                {vol.flag && <span className="ml-auto rounded bg-grass-deep px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-white" data-id="element-386" data-mp="3nthmhk2fe22k">
                    {vol.flag}
                  </span>}
              </div>
              <h3 className="mt-3 font-display text-xl font-extrabold leading-tight text-ink" data-id="element-387" data-mp="3eqqanj5n14ae">{vol.title}</h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-willow-deep" data-id="element-388" data-mp="39sx76xvpyodt">{vol.range}</p>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-389" data-mp="34vye8insknh7">{vol.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-cream-dark pt-4" data-id="element-390" data-mp="301u7o0ifuhgn">
                {vol.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-391" data-mp="2v1xzdp2pk3va">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-cherry" data-id="element-392" data-mp="2r4jsw56ewa6z" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-6 rounded-2xl bg-field px-5 py-5 text-cream sm:px-7" data-id="element-393" data-mp="wmh2whf9d7br">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-willow" data-id="element-394" data-mp="wol2in64jk68">In every volume</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-395" data-mp="11neiqncsppa3">
            {everyVolume.map(item => <li key={item} className="flex gap-2 text-[13px] text-cream/85" data-id="element-396" data-mp="1alzy69mz0o6n">
                <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-willow" data-id="element-397" data-mp="1ajxavxd7d95m" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}